/**
 * Created by lari on 09/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name reminder
   * @description
   *
   */
  angular
    .module('vcreminder', [
    ]);
}());
